import cx from 'classnames'
import { forwardRef } from 'react'
import { useReactNodeView } from '../ReactNodeView/ReactNodeViewContext'
import { LineDividerFormatBar } from './LineDividerFormatBar'
import Styles from './LineDivider.module.scss'
import { ALMANAC_DROP_CURSOR_PLUGIN_KEY } from 'common/Prose/Plugins/AlmanacDropCursor/constants'
import { AlmanacDropCursorPluginMeta } from 'common/Prose/Plugins/AlmanacDropCursor/AlmanacDropCursor'

export const LineDivider = forwardRef<HTMLDivElement, {}>((_render, _contentDomRef) => {
  const context = useReactNodeView()
  const { node, nodeView, view } = context
  const isSelected = context.isSelected ?? false

  const handleDragStart = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault()

    if (!view || !nodeView || !(e.target instanceof HTMLElement)) return

    const lineDividerWrapper = e.target

    const clone = lineDividerWrapper.cloneNode(true) as HTMLElement
    clone.id = 'dragClone'

    const {
      state: { tr },
      dispatch,
    } = view

    const meta: AlmanacDropCursorPluginMeta = {
      action: 'startDrag',
      draggedNodePos: nodeView.getPos(),
      targetElementClone: clone,
    }

    dispatch(tr.setMeta(ALMANAC_DROP_CURSOR_PLUGIN_KEY, meta))
  }

  return (
    <div className={cx(Styles.lineDivider, { [Styles.isSelected]: isSelected })}>
      {isSelected && view?.editable && <LineDividerFormatBar />}

      <div className={Styles.wrapper} draggable={isSelected} onDragStart={handleDragStart}>
        <div className={cx(Styles.container, Styles[node?.attrs.lineStyle])} />
      </div>
    </div>
  )
})
